import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register required Chart.js components
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const signalPatterns: { [key: string]: number[] } = {
  ECG: [0, 1, 0, -0.5, 0, 1.5, 0, -1, 0, 0.5, 0],
  Respiratory: [0, 0.3, 0.6, 0.9, 1, 0.9, 0.6, 0.3, 0],
  PPG: [0, 0.2, 0.8, 1, 0.5, 0.2, 0, 0.1, 0.4, 0.9, 0.6],
};

const EcgCard: React.FC = () => {
  const [signalType, setSignalType] = useState<string>('ECG');
  const [signalData, setSignalData] = useState<number[]>([]);

  useEffect(() => {
    const interval = setInterval(() => {
      setSignalData((prevData) => {
        const pattern = signalPatterns[signalType];
        const index = prevData.length % pattern.length;
        const newData = [...prevData, pattern[index]];
        return newData;
      });
    }, 200); // Mimic realistic signal pace

    return () => clearInterval(interval);
  }, [signalType]);

  const data = {
    labels: Array.from({ length: signalData.length }, (_, i) => i.toString()),
    datasets: [
      {
        label: signalType,
        data: signalData,
        fill: false,
        borderColor: signalType === 'ECG' ? '#00ff00' : signalType === 'Respiratory' ? '#0000ff' : '#ff0000',
        borderWidth: 2,
        tension: 0.3,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      x: { display: false },
      y: { display: false },
    },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
  };

  return (
    <div className="card ecg-card">
      <h3>{signalType} Signal</h3>
      <div>
        <label htmlFor="signal-select">Select Signal: </label>
        <select
          id="signal-select"
          value={signalType}
          onChange={(e) => {
            setSignalType(e.target.value);
            setSignalData([]); // Reset data when signal type changes
          }}
        >
          <option value="ECG">ECG</option>
          <option value="Respiratory">Respiratory</option>
          <option value="PPG">PPG</option>
        </select>
      </div>
      <div className="chart-container">
        <Line data={data} options={options} />
      </div>
    </div>
  );
};

export default EcgCard;
